import { ShieldX } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/shared/components/ui/button';
import { useAuthContext } from '@/shared/contexts/AuthContext';
import { getRoleBasedRedirect } from '@/shared/lib/auth.utils';
import { FORBIDDEN_STRINGS } from '@/shared/constants/strings';

export function Forbidden() {
  const { user } = useAuthContext();
  const navigate = useNavigate();
  const roles = user?.roles ?? [];

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-card rounded-2xl shadow-2xl p-8 text-center">
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 bg-destructive/10 rounded-full flex items-center justify-center">
            <ShieldX className="w-8 h-8 text-destructive" aria-hidden="true" />
          </div>
        </div>

        <p className="text-4xl font-bold text-destructive mb-2">
          {FORBIDDEN_STRINGS.STATUS_CODE}
        </p>

        <h1 className="text-xl font-semibold text-foreground mb-2">
          {FORBIDDEN_STRINGS.TITLE}
        </h1>

        <p className="text-sm text-muted-foreground mb-6">
          {FORBIDDEN_STRINGS.DESCRIPTION}
        </p>

        {roles.length > 0 && (
          <p className="text-sm text-muted-foreground mb-6">
            {FORBIDDEN_STRINGS.ROLE_LABEL}:{' '}
            <span className="font-medium capitalize">{roles.join(', ')}</span>
          </p>
        )}

        <Button onClick={() => navigate(getRoleBasedRedirect(roles))}>
          {FORBIDDEN_STRINGS.CTA_BUTTON}
        </Button>
      </div>
    </div>
  );
}
